import layoutStyles from 'app/scss/layout/layout.module.scss';
import { useRawMode } from '~/context/RawModeContext';
import { useUser } from '~/context/UserContext';

import { useMatches } from '@remix-run/react';

import SidebarDesktopAdPop from '../Ads/PopAds/SidebarDesktopAdPop';
import SidebarSliderDesktopAdPop from '../Ads/PopAds/SidebarSliderDesktopAdPop';
import SidebarDesktopAd from '../Ads/SidebarDesktopAd';
import SidebarSliderDesktopAd from '../Ads/SidebarSliderDesktopAd';
import SignUpCard from '../SignUpCard/SignUpCard';
import SubscribeCard from '../SubscribeCard/SubscribeCard';
import UserCard from '../User/UserCard/UserCard';

const mainRoutes = [
  'routes/article.$slug',
  'routes/_index',
  'routes/discover.$slug',
  'routes/discover._index',
  'routes/search',
  'routes/privacy-policy',
];

const userRoutes = ['routes/user-settings', 'routes/user-notifications'];

const profileRoutes = [
  'routes/user-profile._index',
  'routes/user-profile.topics',
  'routes/user-profile.voted',
  'routes/user-profile.comments',
  'routes/user-profile.newsletter',
];

export default function SidebarRight() {
  const { user } = useUser();
  const { isRaw } = useRawMode();
  const matches = useMatches();

  const currentRoute = matches[matches.length - 1];
  const routeId = currentRoute?.id ?? '';

  const isMainRoute = mainRoutes.includes(routeId);
  const isUserRoute = userRoutes.includes(routeId);
  const isProfileRoute = profileRoutes.includes(routeId);

  return (
    <div className={layoutStyles.contentRight}>
      {isMainRoute && user ? <SubscribeCard /> : <SignUpCard />}

      {isUserRoute && user && <UserCard user={user} />}

      {isProfileRoute && user && <UserCard user={user} withLink />}

      {user?.is_admin && (
        <>
          {isRaw ? <SidebarDesktopAd /> : <SidebarDesktopAdPop />}
          {isRaw ? <SidebarSliderDesktopAd /> : <SidebarSliderDesktopAdPop />}
        </>
      )}
    </div>
  );
}
